export const VdpTitle = {
  // vehicleLocation: the vehicle's store name (feed `location` field), passed
  // from the vdp-title blade so the badge can resolve a per-store city/coords
  // from the GENIUS['locations'] map.
  props: ['lang', 'vehicleLocation'],
  data() {
    return {
      buyerDistanceKm: (typeof window !== 'undefined' && window.LBX_BUYER_DISTANCE_KM != null) ? window.LBX_BUYER_DISTANCE_KM : null,
      buyerPos: (typeof window !== 'undefined' && window.LBX_BUYER_POS) || null,
    };
  },
  created() {
  },
  mounted() {
    var EventBus = window.EventBus;
    var lbxGeo = (typeof window !== 'undefined' && window.LBX_DEALER_LOCATION) || null;
    // City-only mode never geolocates the buyer — just shows the store city.
    if (!EventBus || typeof EventBus.initBuyerDistance !== 'function' || !lbxGeo || !lbxGeo.vdp || lbxGeo.vdpCityOnly) return;
    // Geolocate the buyer once (shared with the SRP card) and show the distance
    // to the vehicle's store in the title badge. See EventBus.initBuyerDistance().
    EventBus.initBuyerDistance();
    EventBus.$on('lbx:buyer-distance', (km) => { this.buyerDistanceKm = km; });
    EventBus.$on('lbx:buyer-position', (pos) => { this.buyerPos = pos; });
  },
  methods: {
    goToCompare(id, lang) {
      lang = this.lang;
      let compare;
      if (!localStorage.compare) {
        var Obj = {
          ids: [id],
        };
        localStorage.setItem('compare', JSON.stringify(Obj));
      } else {
        compare = JSON.parse(localStorage.compare);

        if (compare.ids.indexOf(id) == -1) compare.ids.push(id);

        if (compare.ids.length > 4) {
          compare.ids.splice(0, 1);
        }
        localStorage.compare = JSON.stringify(compare);
      }

      compare = JSON.parse(localStorage.compare);

      var urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4) break;

        urlIds.push(compare.ids[i]);
        j++;
      }

      var slug = '/compare/';
      if (lang == 'fr-CA')
        slug = '/comparer/'
      window.location.href = slug + '?vehicles=' + urlIds.join('|');
    },
    msieversion() {

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      console.log(msie);
      if (msie > 0 || !!navigator.userAgent.match("rv:11")) // If Internet Explorer, return version number
      {
        return true;
      } else {
        return false;
      }
    }
  },
 computed: {
  isIe11(){
    return this.msieversion()
  },
  // Vehicle's city + the buyer's distance to it, same as the SRP card. When the
  // vehicle's store (vehicleLocation prop) has an entry in the
  // GENIUS['locations'] map (window.LBX_DEALER_LOCATION.locations), the badge
  // uses that store's city/coords; otherwise it falls back to the owning-site
  // city/coords. No permission/coords => city only; nothing => no badge.
  locationBadge() {
    var dealer = (typeof window !== 'undefined' && window.LBX_DEALER_LOCATION) || null;
    if (!dealer) return '';
    var entry = null;
    if (dealer.locations && this.vehicleLocation && dealer.locations[this.vehicleLocation]) {
      entry = dealer.locations[this.vehicleLocation];
    }
    var city = entry ? (entry.city || dealer.city || '') : (dealer.city || '');
    var km = null;
    // City-only mode: never compute/show a distance, just the city.
    if (!dealer.vdpCityOnly) {
      if (entry) {
        // A mapped store only shows a distance against its OWN coordinates —
        // never the owning site's, which could be a different city.
        var EventBus = window.EventBus;
        if (this.buyerPos && entry.lat != null && entry.lng != null && EventBus && typeof EventBus.haversineKm === 'function') {
          km = Math.round(EventBus.haversineKm(this.buyerPos.lat, this.buyerPos.lng, entry.lat, entry.lng));
        }
      } else if (this.buyerDistanceKm != null) {
        km = this.buyerDistanceKm;
      }
    }
    if (km != null) {
      return city ? (city + ' (' + km + ' km)') : (km + ' km');
    }
    return city;
  }
 }
};
